// removed by extract-text-webpack-plugin
module.exports = {"scrollPropertiesList":"_1c6ofPx9-GzWzVoYvZ0vyg","modalMessageWrapper":"_3TU8JzVq2d9ML2QlNWqmAt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPropertiesList/OMPropertiesList.scss
// module id = 1666
// module chunks = 0